import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Contexts
import { ThemeProvider } from "./contexts/Themecontext";
import { AuthProvider } from "./contexts/Authcontext";

// Layout Components
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

// Pages
import Home from "./Pages/Home/Home";
import Login from "./Pages/Auth/login";
import Signup from "./Pages/Auth/signup";
import GetStarted from "./Pages/Getstarted/Getstarted";
import StudentDashboard from "./Pages/Auth/StudentDashboard";
//import ProtectedRoute from "./Pages/Auth/ProtectedRoute";
// Home Router Pages
import Research from "./Pages/HomeRouter/Research";
import SecureComputing from "./Pages/HomeRouter/Securecomputing";
import Semiconductor from "./Pages/HomeRouter/Semiconductor";
import Superconductor from "./Pages/HomeRouter/Superconductor";
import About from "./Pages/About/About";

// Career Pages
import Careers from "./Pages/Careers/Careers";
import JobDetails from "./Pages/Careers/Jobdetails";
import JobApplication from "./Pages/Careers/Jobapplication";
import MyApplications from "./Pages/Careers/Myapplications";
import ProtectedRoute from "./Pages/Careers/ProtectedRoute";

// Admin Pages
import AdminLogin from "./Admin/AdminLogin";
import AdminRequestAccess from "./Admin/AdminRequestAccess";
import AdminSignup from "./Admin/AdminSignup";
import AdminDashboard from "./Admin/AdminDashboard";
import AdminProtectedRoute from "./Admin/AdminProtectedRoute";

// Styles
import "./index.css";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ScrollToTop />

          <div className="flex flex-col min-h-screen">
            
            {/* HEADER */}
            <Header />

            {/* MAIN CONTENT */}
            <main className="flex-grow">
              <Routes>
                
                {/* HOME */}
                <Route path="/" element={<Home />} />
                
                {/* GET STARTED */}
                <Route path="/get-started" element={<GetStarted />} />

                {/* CORE ROUTES */}
                <Route path="/research" element={<Research />} />
                <Route path="/semiconductor" element={<Semiconductor />} />
                <Route path="/superconductor" element={<Superconductor />} />
                <Route path="/ai" element={<SecureComputing />} />
                
                {/* ABOUT */}
                <Route path="/about" element={<About />} />

                {/* STATIC PAGES */}
                <Route
                  path="/products"
                  element={
                    <div className="min-h-screen flex items-center justify-center text-2xl">
                      Products Page - Coming Soon
                    </div>
                  }
                />
                
                <Route
                  path="/contact"
                  element={
                    <div className="min-h-screen flex items-center justify-center text-2xl">
                      Contact Page - Coming Soon
                    </div>
                  }
                />

                {/* USER AUTH ROUTES */}
                <Route path="/login" element={<Login />} />
                <Route path="/signup" element={<Signup />} />
                <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <StudentDashboard />
            </ProtectedRoute>
          } 
        />

                {/* CAREER ROUTES - PUBLIC */}
                <Route path="/careers" element={<Careers />} />
                <Route path="/careers/job/:id" element={<JobDetails />} />

                {/* CAREER ROUTES - PROTECTED */}
                <Route
                  path="/careers/job/:id/apply"
                  element={
                    <ProtectedRoute>
                      <JobApplication />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/my-applications"
                  element={
                    <ProtectedRoute>
                      <MyApplications />
                    </ProtectedRoute>
                  }
                />

                {/* ADMIN ROUTES - PUBLIC */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/request-access" element={<AdminRequestAccess />} />
                <Route path="/admin/signup" element={<AdminSignup />} />

                {/* ADMIN ROUTES - PROTECTED */}
                <Route
                  path="/admin/dashboard"
                  element={
                    <AdminProtectedRoute>
                      <AdminDashboard />
                    </AdminProtectedRoute>
                  }
                />

              </Routes>
            </main>

            {/* FOOTER */}
            <Footer />
          </div>

        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;